export const cf7UtmData = () => {

  // Utility to get UTM parameters from URL
  function getUTMParameters() {
    const params = new URLSearchParams(window.location.search);
    const utmFields = ['utm_campaign', 'utm_term', 'utm_medium', 'utm_source', 'utm_content'];
    const utmData = {};

    utmFields.forEach(field => {
      if (params.has(field)) {
        utmData[field] = params.get(field);
      }
    });

    return utmData;
  }

  // Utility to set a cookie
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${JSON.stringify(value)}; path=/; expires=${date.toUTCString()}`;
  }

  // Utility to get a cookie
  function getCookie(name) {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    for (let cookie of cookies) {
      if (cookie.startsWith(`${name}=`)) {
        return JSON.parse(cookie.substring(name.length + 1));
      }
    }
    return null;
  }

  // Populate UTM fields in forms
  function populateUTMFields(data) {
    if (!data) return;

    console.log('data == ', data);

    // Define the UTM-related field selectors
    const fieldSelectors = [
      'input.utm_event_tracker_campaign',
      'input.utm_event_tracker_term',
      'input.utm_event_tracker_medium',
      'input.utm_event_tracker_source',
      'input.utm_event_tracker_content',
    ];

    const fields = document.querySelectorAll(fieldSelectors.join(','));

    if (!fields.length) {
      console.warn('No UTM-related fields found on the page.');
      return; // Exit if no fields are found
    }

    // Map between extracted paramName and data keys
    const paramMap = {
      campaign: 'utm_campaign',
      term: 'utm_term',
      medium: 'utm_medium',
      source: 'utm_source',
      content: 'utm_content',
    };

    // Populate each field with the corresponding UTM parameter
    fields.forEach(field => {
      console.log('Processing field:', field);
      const paramName = field.className.match(/utm_event_tracker_(\w+)/)?.[1];
      console.log('Extracted paramName == ', paramName);

      if (paramName && paramMap[paramName] && data[paramMap[paramName]]) {
        field.value = data[paramMap[paramName]];
        console.log(`Populated field "${field.name}" with value: ${data[paramMap[paramName]]}`);
      } else {
        console.warn(`No matching data found for paramName: "${paramName}"`);
      }
    });
  }

  // Main logic
  const utmData = getUTMParameters();
  const cookieName = 'wordpress_utm_event_tracker_session';
  const storedData = getCookie(cookieName);

  if (Object.keys(utmData).length > 0) {
    // Set new cookie if UTM data is present
    setCookie(cookieName, utmData, 30);
  }

  // Use cookie or UTM data to populate fields
  populateUTMFields(storedData || utmData);
}